import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  wide?: boolean; // Use max-w-screen-2xl instead of max-w-container
  narrow?: boolean; // For backwards compatibility (same as !wide, i.e., max-w-4xl)
  className?: string;
}

/**
 * Fluid grid container — max 1200px, 24px gutters, 8px vertical rhythm.
 */
export default function PageShell({ children, wide = false, narrow = false, className }: PageShellProps) {
  // narrow=true is equivalent to max-w-4xl for backwards compatibility
  const maxWidthClass = narrow ? 'max-w-4xl' : (wide ? 'max-w-screen-2xl' : 'max-w-container');

  return (
    <div
      className={`mx-auto w-full grid grid-cols-1 gap-section md:grid-cols-12 md:gap-gutter ${maxWidthClass} ${className ?? ''}`}
    >
      <div className="col-span-1 md:col-span-12 space-y-8">{children}</div>
    </div>
  );
}